import React from 'react'
import { Button, Table, Container, Row, Col } from 'reactstrap'
const { uploadGlobalFile } = require('../../model/request/files')

const GLOBAL_FILE_IDS = ['quote-instructions']

class GlobalFilesAdminViewController extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            uploading: {},
            messages: {},
        }
        this.fileInputRefs = {}
        GLOBAL_FILE_IDS.forEach(id => {
            this.fileInputRefs[id] = React.createRef()
        })
    }

    upload(id) {
        const input = this.fileInputRefs[id].current
        if (!input || !input.files || !input.files[0]) return
        const file = input.files[0]

        this.setState(s => ({ uploading: { ...s.uploading, [id]: true }, messages: { ...s.messages, [id]: '' } }))

        uploadGlobalFile(id, file).then(
            () => {
                input.value = ''
                this.setState(s => ({
                    uploading: { ...s.uploading, [id]: false },
                    messages: { ...s.messages, [id]: 'Uploaded successfully.' },
                }))
            },
            (error) => {
                this.setState(s => ({
                    uploading: { ...s.uploading, [id]: false },
                    messages: { ...s.messages, [id]: 'Upload failed.' },
                }))
                this.props.showError(error)
            },
        )
    }

    render() {
        const { uploading, messages } = this.state
        return (
            <Container>
                <h3 style={{ marginTop: '20px', marginBottom: '20px' }}>Global Files</h3>
                <Row><Col><div style={{'overflowX': 'auto'}}><Table>
                    <thead>
                        <tr>
                            <th>File ID</th>
                            <th>File</th>
                            <th style={{ width: '120px' }}>Upload</th>
                            <th>Status</th>
                            <th style={{ width: '120px' }}>Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        {GLOBAL_FILE_IDS.map(id => (
                            <tr key={id}>
                                <td style={{ verticalAlign: 'middle' }}>{id}</td>
                                <td style={{ verticalAlign: 'middle' }}>
                                    <input type="file" ref={this.fileInputRefs[id]} />
                                </td>
                                <td style={{ verticalAlign: 'middle' }}>
                                    <Button
                                        color="primary"
                                        disabled={!!uploading[id]}
                                        onClick={() => this.upload(id)}
                                    >
                                        {uploading[id] ? 'Uploading…' : 'Upload'}
                                    </Button>
                                </td>
                                <td style={{ verticalAlign: 'middle' }}>
                                    {messages[id] || ''}
                                </td>
                                <td style={{ verticalAlign: 'middle' }}>
                                    <a href={'/api/file/global/' + id + '/' + id + '.pdf'} target="_blank" rel="noreferrer">
                                        Download
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table></div></Col></Row>
            </Container>
        )
    }
}

export default GlobalFilesAdminViewController
